import React from 'react';
import type { IconProps } from '../types';

export const Save = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="icon-save"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="24"
        height="24"
      ></rect>
      <path
        d="M4.75,6.75 C4.75,5.6454305 5.6454305,4.75 6.75,4.75 L15.4142136,4.75 L19.25,8.5857864 L19.25,17.25 C19.25,18.3545695 18.3545695,19.25 17.25,19.25 L6.75,19.25 C5.6454305,19.25 4.75,18.3545695 4.75,17.25 L4.75,6.75 Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <polyline
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        points="8.75 4.75 8.75 9.25 15.25 9.25 15.25 4.75"
      ></polyline>
      <polyline
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        points="7.75 19.25 7.75 13.25 16.25 13.25 16.25 19.25"
      ></polyline>
    </g>
  </svg>
);

export default Save;
